/**
 * estoque-page.js — Entry point da página estoque.html
 */

import { initHeader }         from '../components/header.js';
import { initSmoothScroll }   from '../components/smooth-scroll.js';
import { applyConfiguracoes } from '../components/configuracoes.js';
import { renderFooter }       from '../components/footer.js';
import { renderEstoque }      from '../components/estoque.js';
import { initFiltro }         from '../components/filtro.js';
import { initComparar, toggleComparar } from '../components/comparar.js';

document.addEventListener('DOMContentLoaded', async () => {
  renderFooter();
  initHeader();
  initSmoothScroll();
  applyConfiguracoes();

  // O estoque deve terminar de carregar antes do filtro inicializar
  await renderEstoque();
  await initFiltro();
  initComparar();

  // Delegar cliques nos botões "Comparar" do grid
  const grid = document.getElementById('stock-grid');
  if (grid) {
    grid.addEventListener('click', e => {
      const btn = e.target.closest('.btn-comparar');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      toggleComparar(btn.dataset.carId, {
        slug:  btn.dataset.carSlug,
        img:   btn.dataset.carImg,
        name:  btn.dataset.carName,
        price: btn.dataset.carPrice,
      });
    });
  }

  // Se houver query params, preencher a busca e disparar
  const urlParams = new URLSearchParams(window.location.search);
  const q = urlParams.get('q');
  const marca = urlParams.get('marca');
  const cambio = urlParams.get('cambio');
  const combustivel = urlParams.get('combustivel');
  const ordem = urlParams.get('ordem');
  
  if (q) {
    const searchInput = document.getElementById('search-input');
    if (searchInput) {
      searchInput.value = q;
      searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
  if (marca) {
    const selMarca = document.getElementById('filter-marca');
    if (selMarca) {
      selMarca.value = marca;
      selMarca.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  if (cambio) {
    const selCambio = document.getElementById('filter-cambio');
    if (selCambio) {
      selCambio.value = cambio;
      selCambio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  if (combustivel) {
    const selCombustivel = document.getElementById('filter-combustivel');
    if (selCombustivel) {
      selCombustivel.value = combustivel;
      selCombustivel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  if (ordem) {
    const selOrdem = document.getElementById('filter-ordem');
    if (selOrdem) {
      selOrdem.value = ordem;
      selOrdem.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});
